import classNames from 'classnames/bind';
import React from 'react';
import { KnitLink } from '../../../../../KnitLink';
import styles from '../style.module.scss';

const cx = classNames.bind(styles);

interface LogoutButtonProps {
  onClick: (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>,
  ) => void;
}

const LogoutButton = ({ onClick }: LogoutButtonProps) => {
  return (
    <KnitLink
      data-ga="meganav-primary-dropdown-logout"
      onClick={onClick}
      className={cx('section-row', 'section-row-link')}
      to="#"
    >
      Sign Out
    </KnitLink>
  );
};

export default LogoutButton;
